import React, { useEffect, useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import noDataToDisplay from "highcharts/modules/no-data-to-display";

const Graph = ({ data, timezone, t, menuIsOpen, buildingType }) => {
    const chart = useRef(null);
    const months = t("forms.graphMeses").split("-");
    const days = t("forms.graphDays").split("-");

    noDataToDisplay(Highcharts);
    const newData = { totalizador: [], caudal: [], nivelFreaticoDelPozo: [], alturaLimnimetrica: [] };

    data && Array.isArray(data) && data.forEach(d => {
        const formatCaudal = d.caudal ? parseFloat(d.caudal.toFixed(2)) : d.caudal;
        const formatTotalizador = Math.floor(d.totalizador);
        const formatNvlFreatico = (d.nivelFreaticoDelPozo && d.nivelFreaticoDelPozo !== "") ? parseFloat(d.nivelFreaticoDelPozo.toFixed(2)) : undefined;
        const formatAlturaLimnimetrica = d.alturaLimnimetrica ? parseFloat(d.alturaLimnimetrica.toFixed(2)) : d.alturaLimnimetrica;

        newData.totalizador.push({ x: d.fecha, y: formatTotalizador });
        newData.caudal.push({ x: d.fecha, y: formatCaudal });
        newData.nivelFreaticoDelPozo.push({ x: d.fecha, y: formatNvlFreatico });
        newData.alturaLimnimetrica.push({ x: d.fecha, y: formatAlturaLimnimetrica });
    });

    const yAxis = [{ // Primary yAxis
        labels: {
            format: "{value} l/s",
            style: {
                color: "#ff822b",
                fontWeight: "bold"
            }
        },
        title: {
            text: t("forms.graphCaudal"),
            style: {
                color: "#ff822b",
                fontWeight: "bold"
            }
        }
    }, { // Secondary yAxis
        gridLineWidth: 0,
        title: {
            text: t("forms.graphTotalizador"),
            style: {
                color: "#0081ab",
                fontWeight: "bold"
            }
        },
        labels: {
            format: "{value} m³",
            style: {
                color: "#0081ab",
                fontWeight: "bold"
            }
        }
    }, { // Tertiary yAxis
        gridLineWidth: 0,
        title: {
            text: buildingType === "SUPERFICIAL" ? t("forms.graphAlturaLimnimetrica") : t("forms.graphNvlFreatico"),
            style: {
                color: "#2fa201",
                fontWeight: "bold"
            }
        },
        labels: {
            format: `{value} ${buildingType === "SUPERFICIAL" ? "cm" : "m"}`,
            style: {
                color: "#2fa201",
                fontWeight: "bold"
            }
        },
        opposite: true
    }];

    const series = [{
        name: t("forms.graphCaudal"),
        type: "spline",
        color: "#ff822b",
        yAxis: 0,
        data: newData.caudal,
        tooltip: {
            valueSuffix: " l/s"
        }
    }, {
        name: t("forms.graphTotalizador"),
        type: "spline",
        color: "#0081ab",
        yAxis: 1,
        data: newData.totalizador,
        marker: {
            enabled: false
        },
        dashStyle: "shortdot",
        tooltip: {
            valueSuffix: " m³"
        }
    }, {
        name: buildingType === "SUPERFICIAL" ? t("forms.graphAlturaLimnimetrica") : t("forms.graphNvlFreatico"),
        type: "spline",
        color: "#2fa201",
        yAxis: 2,
        data: buildingType === "SUPERFICIAL" ? newData.alturaLimnimetrica : newData.nivelFreaticoDelPozo,
        tooltip: {
            valueSuffix: buildingType === "SUPERFICIAL" ? " cm" : " m"
        }
    }];

    const options = {
        lang: {
            noData: t("forms.graphNoData")
        },
        time: {
            timezone: timezone,
            useUTC: false
        },
        chart: {
            zoomType: "xy",
            hideNoData: true,
            showNoData: t("forms.graphNoData")
        },
        title: {
            text: null
        },
        subtitle: {
            text: null,
            align: "left"
        },
        xAxis: [{ // Bottom X axis
            type: "datetime",
            crosshair: true,
            minorTickInterval: 36e5,
            tickInterval: 36e5,
            tickLength: 0,
            dateTimeLabelFormats: {
                hour: t("forms.graphXaxisHourFormat")
            }
        }],
        yAxis: yAxis,
        tooltip: {
            shared: true
        },
        credits:
        {
            enabled: false
        },
        series: series,
        plotOptions: {
            spline: {
                tooltip: {
                    dateTimeLabelFormats: {
                        hour: t("forms.graphDateFormat")
                    }
                }
            }
        }
    };

    useEffect(() => {
        if (chart?.current?.chart !== null) {
            setTimeout(() => {
                chart?.current?.chart?.reflow?.();
            }, 500);
        }
    }, [menuIsOpen]);

    useEffect(() => {
        if (!newData.totalizador.length && !newData.nivelFreaticoDelPozo.length && !newData.caudal.length) {
            chart.current?.chart?.hideNoData();
            chart.current?.chart?.showNoData(t("forms.graphNoData"));
        }
        if (newData.totalizador.length || newData.nivelFreaticoDelPozo.length || newData.caudal.length) {
            chart.current?.chart?.hideNoData();
        }
    }, [t]);

    Highcharts.setOptions({
        lang: {
            resetZoom: t("forms.graphResetZoom"),
            loading: t("forms.graphCargando"),
            months: months,
            weekdays: days,
            shortMonths: months,
            shortWeekdays: days
        }
    });

    return (
        <HighchartsReact ref={chart} highcharts={Highcharts} options={options} />
    );
};

export default Graph;
